import React from 'react';
import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagic } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useEnrichment } from 'context/EnrichmentContext';

/**
 * EnrichmentGlobalIndicator - Header badge showing enrichment progress.
 *
 * Appears when enrichment is processing.
 * Click navigates back to Products page.
 */
const EnrichmentGlobalIndicator = () => {
  const { isProcessing, progress } = useEnrichment();
  const navigate = useNavigate();

  // Only show when actively processing
  if (!isProcessing) return null;

  const handleClick = () => {
    navigate('/products');
  };

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip>
          Enriching {progress.completed}/{progress.total} products
          <br />
          Click to view progress
        </Tooltip>
      }
    >
      <Badge
        bg="primary"
        className="enrichment-global-indicator me-2"
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          padding: '6px 10px',
          fontSize: '0.75rem'
        }}
        onClick={handleClick}
      >
        <FontAwesomeIcon icon={faMagic} spin className="me-1" />
        {progress.completed}/{progress.total}
      </Badge>
    </OverlayTrigger>
  );
};

// Inject pulse animation CSS
if (typeof document !== 'undefined') {
  const existingStyle = document.querySelector('[data-enrichment-indicator-style]');
  if (!existingStyle) {
    const style = document.createElement('style');
    style.setAttribute('data-enrichment-indicator-style', 'true');
    style.textContent = `
      @keyframes enrichment-pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.7; }
      }
      .enrichment-global-indicator {
        animation: enrichment-pulse 2s infinite !important;
      }
    `;
    document.head.appendChild(style);
  }
}

export default EnrichmentGlobalIndicator;
